import { $getRoot, EditorState } from 'lexical';

export const stateToText = (state: EditorState) =>
  state.read(() => $getRoot().getTextContent());
